import React from 'react';

import Grid from '@material-ui/core/Grid';

import DashboardLayout from '../../layouts/dashboard';
import { DriversDetail } from '../../../components/Drivers/DriversDetail';

export const DriversDetailsPage = () => {
  return (
    <DashboardLayout title={'Chofer'}>
      <Grid
        container
        spacing={0}
        direction="row"
        alignItems="flex-start"
        justifyContent="flex-start"
        style={{ minHeight: '100vh' }}
      >
        <Grid item xs>
          <DriversDetail />
        </Grid>
      </Grid>
    </DashboardLayout>
  );
};
